import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { timeFormat } from '../../../constants/time';

import {
  Avatar,
  Grid,
} from '../../base';

const useStyles = makeStyles(theme => ({
    container: {
      display: 'flex',
      marginBottom: theme.spacing(3),
      alignItems: 'flex-end',
      width: '100%',

      [theme.breakpoints.up('lg')]: {
        width: '50%',
      },
    },
    avatar: {
      fontSize: theme.typography.caption.fontSize,
    },
    infoContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: theme.spacing(2),
    },
    userRow: {
      marginBottom: theme.spacing(),
      fontSize: 18,
    },
    infoRow: {
      marginBottom: theme.spacing(),
      color: 'rgba(0, 0, 0, 0.7)',
      wordBreak: 'break-all',
      fontSize: 18,
    },
    timeRow: {
      fontSize: 18,
      fontWeight: 300,
    },
  }));

const Comment = ({comment}) => {
    const c = useStyles();

    return (
        <Grid item className={c.container}>
          <Avatar className={c.avatar} />
          <div className={c.infoContainer}>
            <div className={c.infoRow}> <span>{comment.text}</span></div>
            <div className={c.userRow}>{comment.user + ' - '}
            <time
              dateTime={comment.timeOfAction}
              className={c.timeRow}
            >
              {moment(comment.timeOfComment).format(timeFormat.MINUTES)}
            </time>
            </div>
          </div>
        </Grid>
    );
}

export default Comment;



// WEBPACK FOOTER //
// ./src/components/ConversationSection/Comment/Comment.js